<div class="col-sm-6">
  <h1 class="h2 text-primary">
    <span *ngIf="step === LoginJourney.Username">{{ headerName }}</span>
    <span *ngIf="step === LoginJourney.Bound">Enter your Passcode</span>
    <span *ngIf="step === LoginJourney.Unbound">Enter Passcode</span>
    <span *ngIf="step === LoginJourney.OtpDeliverySelection"
      >One-time passcode</span
    >
    <span *ngIf="step === LoginJourney.OtpInput">Enter code</span>
  </h1>
  <p>
    <span *ngIf="step === LoginJourney.Bound || step === LoginJourney.Unbound"
      >Please enter the requested digits from your passcode log in</span
    >
    <span *ngIf="step === LoginJourney.OtpDeliverySelection"
      >For security reasons, we'll ask you to enter a 6 digit one-time passcode.
      Please select how you would like to receive it.</span
    >
    <span *ngIf="step === LoginJourney.OtpInput">
      Please enter the 6 digit one-time passcode sent to ******<strong>{{
        selectedOTPChannel === OtpChannel.Call
          ? homeNumberEnding
          : mobileNumberEnding
      }}</strong></span
    >
  </p>
  <p *ngIf="step === LoginJourney.Username">{{ bodyContent }}</p>
  <br />
  <p *ngIf="step === LoginJourney.Username && registrationAllowed">
    Not yet registered for Online Account Manager?
    <a
      (click)="onClickRegisterLink($event)"
      [routerLink]="registerLink.url"
      attr.aria-label="{{ registerLink.text }}"
      tabindex="1"
    >
      {{ registerLink.text }}
    </a>
  </p>
</div>
